import React, { useContext } from "react";
import FormContext from "../../context/FormContext";

import SidebarItems from "./SidebarItems";

function Sidebar() {
  const context = useContext(FormContext);
  const { Branch } = context;
  console.log(Branch);
  return (
    <React.Fragment>
      <div id="sidebar_body">
        <div className="p-2 text-center">
          <img
            style={{ width: 100, borderRadius: 10 }}
            alt="logo"
            src={`https://erp.eshiksa.net/esh/${Branch.logopath}`}
          />
          <h5 className="text-bold my-2">{Branch.BranchName}</h5>
        </div>
        <SidebarItems />
      </div>
    </React.Fragment>
  );
}

export default Sidebar;
